import React, { useEffect, useState } from "react";
import LoginForm from "./LoginForm";
import { IMAGES } from "../../../assets";
import { STRINGS } from "../../../constants";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { getInstituteInfo } from "../../../api/user";
import { FILE_URL } from "../../../constants/Constants";

const InstituteLogin = () => {
  const { t } = useTranslation();
  const { instituteId } = useParams();
  const [instituteData, setInstituteData] = useState();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInstituteInfo = async () => {
      if (instituteId) {
        setLoading(true); // Set loading to true when fetching data
        const result = await getInstituteInfo({ id: instituteId });
        if (result?.status) {
          setInstituteData(result?.data?.body?.userDetail);
        } else {
          setInstituteData(null);
        }
        setLoading(false); // Set loading to false after data is fetched
      }
    };

    fetchInstituteInfo();
  }, [instituteId]);

  // console.log(instituteData);

  return (
    <div className="w-full  ">
      <div className="w-[100%]    flex h-[100vh]">
        <div className="w-[50%] relative h-full  bg-[#FE6B010F] lg:block md:hidden sm:hidden hidden  ">
          <div className="flex flex-col items-center justify-between h-full">
            <div className="h-72 w-full relative bottom-0 mt-12 rounded-full">
              {/* Display loader or image based on loading state */}
              {loading ? (
                // Placeholder or loading spinner
                <div className="h-full w-full flex items-center justify-center">
                  <div className="spinner" />{" "}
                  {/* You can use a spinner component here */}
                </div>
              ) : (
                <img
                  src={
                    instituteData?.instituteImage
                      ? FILE_URL + instituteData.instituteImage
                      : process.env.PUBLIC_URL + "/front" + IMAGES?.logo
                  }
                  alt="logo"
                  className="h-full w-full object-contain rounded-none"
                />
              )}
            </div>
            <img
              alt="login_svg"
              src={`${process.env.PUBLIC_URL + "/front"}${
                IMAGES?.reading_ledy
              }`}
              className="w-auto h-52 bottom-0 relative"
            />
          </div>
        </div>
        <div className="w-full   lg:w-[50%]  md:w-full  sm:w-full  px-4   sm:px-28  py-2 flex flex-col justify-center items-center relative">
          <div className=" flex flex-col max-w-[345px]">
            <h2 className="py-1 font-semibold text-3xl">{t(STRINGS.login)}</h2>
            <p className="py-2 text-paragraph pb-3">
              {t(STRINGS.please_enter_your_email_and_password)}
            </p>
            <LoginForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstituteLogin;
